import React, {useEffect, useState } from 'react'
import LCLSummaryMobile from '../../components/DeviceSummary/LCLSummaryMobile'
import { CreateUrl, CallGetAPI, CallPutAPI, CallPostAPI } from 'Utils/ApiHelper.js';
import { useMobileLandscape, useTabletContext } from '../../Context/ContextProvider'
import { injectIntl, FormattedMessage, IntlShape, useIntl } from 'react-intl';
import { APIGetLoggerReportsModel, buildAPIGetLoggerReportsModel } from '../../models/APIGetLoggerReportsModel';
import CHF from "assets/CHF.png";
import CHF1P from "assets/CHF1P.png";
import CHF2P from "assets/CHF2P.png";
import ZL from "assets/ZoneLog_Logger.png"
import Loader from '../../Utils/Loader/NewLoader2025'
import LCLDeviceSetupOverview from './LCLDeviceSetupOverviewMobile'
import moment from 'moment'
import FullWidthMobileButton from '../../components/FullWidthMobileButton';
import { Accordion, Item, AccordionTypes } from 'devextreme-react/accordion';
import MobileImagePanel from '../../components/ImageUpload/MobileImagePanel';
import UploadDialog from "../../components/ImageUpload/UploadDialog"
import Comments from '../../components/Comments/Comments';
import EventsPanelMobile from '../../components/Events/EventsPanelMobile';
import ConfigurationPanel from '../../components/Connections/ConfigurationsPanel'
import Modal from 'react-bootstrap/Modal';
import GoogleMapsMobileDash from '../../components/Map/GoogleMapsMobileDash'
import type { google } from 'google.maps'
import yellowMarker from '../../assets/mapLocationMarkers/pinYellow.png';
import { APIGetLoggerEventsModel, buildAPIGetLoggerEventsModel } from "models/APIGetLoggerEventsModel";
import { APIGetLoggerConnectionsModel, buildAPIGetLoggerConnectionsModel } from "models/APIGetLoggerConnectionsModel";
import { Redirect } from 'react-router-dom'

interface Props {
    history: {
        goBack: () => void;
    };
    location: {
        state: {
            serial: string;
        };
        search: string;
    };
}

interface MqttMessage {
    companyGuid: string;
    created: Date | string;
    data: string;
    decoded: Date | string;
    id: number;
    length: number;
    loggerGuid: string;
    loggerId: number;
    phoneNumbers: string;
    rtCheader: Date | string;
    seqNum: number;
    serial: number;
    subscriberId: string;
    subscriberTopic: string;
    topic: string;
}


interface GPS {
    position: { lat: number, lng: number }
    icon: string
    serial: number
    id: number
    deviceName: string
}


interface RedirectProps {
    serial: number
}

const LCLDeviceDetailMobile: React.FC<Props> = ({ history, location }) => {
    //hooks and context
    const intl: IntlShape = useIntl()
    const isLandscape = useMobileLandscape()
    const isTablet = useTabletContext()
    ///use effects
    useEffect(() => {
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
        //reloadData()
    }, [])




    //state
    const [deviceData, setDeviceData] = useState<APIGetLoggerReportsModel | null>()
    const [imageSrc, setImageSrc] = useState<string>("")
    const [loading, setLoading] = useState<boolean>(true)
    const [MqttConfigArr, setMqttConfigArr] = useState<Array<MqttMessage>>([])
    const [MqttConfigSigArr, setMqttConfigSigArr] = useState<Array<MqttMessage>>([])
    const [uploadDialogOpen, setUploadDialogOpen] = useState<boolean>(false)
    const [mapModal, setMapModal] = useState<boolean>(false)
    const [markers, setMarkers] = useState<Array<GPS>>([])
    const [googleMapInstance, setGoogleMapInstance] = useState<google.maps.Map | null>()
    const [eventData, setEventData] = useState<APIGetLoggerEventsModel>()
    const [connectionsData, setConnectionsData] = useState<Array<APIGetLoggerConnectionsModel>>([])
    const [redirect, setRedirect] = useState<boolean>(false)
    const [redirectPath, setRedirectPath] = useState<string>("")
    const [redirectProps, setRedirectProps] = useState<RedirectProps | null>()
    const [disableBackBtn, setDisableBackBtn] = useState<boolean>(false)
    const [serialMessage, setSerialMessage] = useState<string>(``)
    const [countDown, setCountDown] = useState<number>(3)


    useEffect(() => {
        fitBoundsToMarkers()
    }, [markers, googleMapInstance])


    console.log(location)
    useEffect(() => {
        if (location.state  && location.state?.serial !== deviceData?.serial) {
            reloadData(location.state.serial)
            setDisableBackBtn(false)
        } else {
            reloadData(location.search.slice(8))
            setDisableBackBtn(true)
        }
    }, [location.state?.serial || location.search])


    const fitBoundsToMarkers = (): void => {
        if (googleMapInstance && markers.length > 0) {
            const bounds = new window.google.maps.LatLngBounds();
            markers.forEach((marker) => {
                bounds.extend(marker.position);
            });
            googleMapInstance.fitBounds(bounds);
        }
    };

    const reloadData = (serial): void => {
        setLoading(true)
        CallGetAPI(CreateUrl('/api/aquaguard/LoggerReportBySerial?serial=' + serial), {})
            .then(data => {
                const deviceDataTemp = buildAPIGetLoggerReportsModel(data[0])
                console.log(deviceDataTemp)
                setMarkers([{
                    position: { lat: deviceDataTemp.latitude ? deviceDataTemp.latitude : null, lng: deviceDataTemp.longitude ? deviceDataTemp.longitude : null },
                    icon: yellowMarker,
                    serial: deviceDataTemp.serial,
                    id: deviceDataTemp.lcloggerid,
                    deviceName: deviceDataTemp.siteid
                }])
                let imgSrc = CHF
                if (window.location.hostname.includes('zonelog.net')) {
                    imgSrc = ZL

                } else {
                    if (deviceDataTemp.product?.toString().includes('2P')) {
                        imgSrc = CHF2P
                    } else if (deviceDataTemp.product?.toString().includes('1P')) {
                        imgSrc = CHF1P
                    }
                }
                CallGetAPI(CreateUrl(`/api/MqttMessages/loggerserial?serial=${deviceDataTemp.serial}&type=sigcheck`), {})
                    .then(mqttSig => {
                        setMqttConfigSigArr(mqttSig)
                    })
                    .catch(err => console.error(err))
                setDeviceData(deviceDataTemp)
                setImageSrc(imgSrc)
                CallGetAPI(CreateUrl(`/api/MqttMessages/loggerserial?serial=${deviceDataTemp.serial}&type=config`), {})
                    .then(mqtt => {
                        console.log(mqtt)

                        setMqttConfigArr(mqtt)
                        const startDateFormatted = moment().subtract(2, 'days').format("YYYY-MM-DD");
                        const endDateFormatted = moment().format("YYYY-MM-DD");
                        let eventInfo: APIGetLoggerEventsModel[] = [];
                        // Looks for log events from the last 7 days - battery logs should happen daily
                        CallGetAPI(CreateUrl(`/api/aquaguard/LoggerEvents?serial=${serial}&startDate=${startDateFormatted}&endDate=${endDateFormatted}`), {})
                            .then(response => {
                                console.log(response)
                                eventInfo = buildAPIGetLoggerEventsModel(response);
                                const batteryInfo = eventInfo.filter(item => {
                                    return item.remainingBattPerc !== null
                                })

                                if (batteryInfo.length > 0) {
                                    setEventData(batteryInfo[0])
                                }
                                CallGetAPI(CreateUrl('/api/aquaguard/LoggerConnections?serial=' + deviceDataTemp.serial + "&startDate=" + moment().subtract(7, "days").format("yyyy-MM-DD") + "&endDate=" + moment().endOf("day").format("yyyy-MM-DDTHH:mm:ss")), {})
                                    .then(json => {
                                        console.log(json)
                                        let connectionsDataTemp: APIGetLoggerConnectionsModel[] = []
                                        connectionsDataTemp = connectionsDataTemp.concat(buildAPIGetLoggerConnectionsModel(json));
                                        console.log(connectionsData)
                                        setConnectionsData(connectionsDataTemp)
                                        setLoading(false)
                                    })
                                    .catch(function (ex) {
                                        setConnectionsData([])
                                        console.error(ex);
                                        setLoading(false)
                                    })
                            })
                            .catch(err => {
                                console.log(err)
                                setLoading(false)
                            });
                    })
                    .catch(err => {
                        console.error(err)
                        setLoading(false)
                    })


            })
            .catch(err => {
                console.error(err, serial)
                if (serial) {
                    setSerialMessage(intl.formatMessage({ id: 'Device Not Found in System - Redirecting to dashboard in' }))
                    for (let i = 3; i > 0; i--) {
                        setTimeout(() => {
                            setCountDown(i)
                            if (i === 1) {
                                setTimeout(() => {
                                    setRedirect(true)
                                    setRedirectPath('/portal/dashboard')
                                }, 1000)
                            }
                        }, (4- i) *1000)
                    }
                }
                setLoading(false)
            })
    }



    const handleMapClick = (): void => {
        toggleMapModal()
    }

    const handleUploadPhoto = (): void => {
        setUploadDialogOpen(!uploadDialogOpen)
    }


    const toggleMapModal = (): void => {
        setMapModal(!mapModal)
    }

    const onMapLoad = (map: google.maps.Map): void => {
        map.setMapTypeId("hybrid");
        map.setZoom(15);
        setGoogleMapInstance(map)
    };

    const handleGraphClick = (): void => {
        console.log(deviceData)
        sessionStorage.setItem('selectedLoggers', String(deviceData?.lcloggerid + 500000))
        setRedirect(true)
        setRedirectPath('/portal/multiLoggerGraph')
        setRedirectProps(
            {
                groupId: null,
                loggers: [deviceData?.lcloggerid + 500000],
                loggerId: null,
                showBackButton: true,
                serial: null
            }
        )
    }

    const handleBackClick = () => {
        if (!disableBackBtn) {
            history.goBack()
        } else {
            window.location.href = '/portal/dashboard'
        }
    }

   


    return (<>{!redirect ? <div>
        <UploadDialog
            show={uploadDialogOpen}
            title={intl.formatMessage({ id: "Upload Image" })}
            siteId={0}
            loggerId={deviceData?.lcloggerid + 500000}
            onSubmit={(): void => {
                setUploadDialogOpen(false)
                reloadData()
            }}
            onCancel={(): void => setUploadDialogOpen(false)}
        />
        <Modal
            show={mapModal}
            style={{
                marginTop: isLandscape ? "20px" : "100px",
            }}
        >
            <Modal.Header>
                <Modal.Title>
                    <FormattedMessage id='Map' />
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div style={{ margin: "0 5px 0 8px" }}>
                    <GoogleMapsMobileDash
                        onMapLoad={onMapLoad}
                        markers={markers}
                        handleMarkerClick={(): void => {/**/ }}
                        showTooltip={false}
                        clickedMarker={null}
                        handleTooltipCloseClick={(): void => {/**/ }}
                        deviceOverviewClick={(): void => {/**/ }}
                        center={markers[0]?.position}
                    />
                </div>
            </Modal.Body>
            <Modal.Footer>
                <FullWidthMobileButton disabled={false} color="primary" onClick={(): void => toggleMapModal()} text={intl.formatMessage({ id: "Exit" })} />
            </Modal.Footer>
        </Modal>
        {serialMessage &&
            <div
                style={{
                    position: 'relative',
                    left: 'Calc(50% - 130px)',
                    top: 'Calc(50vh - 180px)'
                }}
            >
                <h4><b>{serialMessage} {countDown.toString()}</b></h4>
            </div>
        }
        {loading && <div style={{
            position: 'relative', left: 'Calc(50% - 100px)', top: 'Calc(50vh - 200px)'
        }}>
            <Loader color={undefined} />
        </div>}
        {!loading && !serialMessage && <div>
                
            <div style={{ display: "flex", justifyContent: "center", margin: "-20px 0 20px 0" }}>
                <div>
                    <div style={{ display: "flex", justifyContent: "center" }}>
                        <img style={{ margin: 0 }} src={imageSrc} width="150" height="84" />
                    </div>
                    <h3 style={{ margin: 0 }}><b>{`${intl.formatMessage({ id: 'Serial' })}: ${deviceData?.serial}`}</b></h3>
                </div>
            </div>
            <LCLDeviceSetupOverview deviceConfig={MqttConfigArr.length > 0} invertColors={false} signalCheck={MqttConfigSigArr.length > 0}  />
            <div style={{ display: "flex", width: "100%", justifyContent: "space-between", marginTop: 30 }}>
                <div style={{ width: "47%" }}>
                    <FullWidthMobileButton disabled={false} text={intl.formatMessage({ id: "Back" })} color="error" onClick={(): void => handleBackClick()} />
                </div>
                <div style={{ width: "47%" }}>
                    <FullWidthMobileButton disabled={false} text={intl.formatMessage({ id: "Map" })} color="secondary" onClick={(): void => handleMapClick()} />
                </div>
                
            </div>
            <div style={{ marginTop: "20px" }}>
                <FullWidthMobileButton disabled={false} text={intl.formatMessage({ id: "Graph" })} color="primary" onClick={(): void => handleGraphClick()} />
            </div>
            <div style={{ width: (isLandscape || isTablet) ? "100%" : "120%", transform: (isLandscape || isTablet) ? "none" : "translateX(-8%)" }}>
                <Accordion
                    collapsible={true}
                    multiple={true}
                    style={{ background: '#eeeeee', color: "black", marginTop: "20px" }}
                    defaultSelectedIndex={0}
                >
                    <Item title={intl.formatMessage({ id: "Device Overview" })}>
                        <div>
                            <LCLSummaryMobile deviceData={deviceData} eventData={eventData} connectionsData={connectionsData} />
                        </div>
                    </Item>
                    <Item title={intl.formatMessage({ id: 'Images' })}>
                        <div style={{ marginTop: 10 }}>
                            <FullWidthMobileButton disabled={false} text={intl.formatMessage({ id: "upload/capture" })} color="primary" onClick={(): void => handleUploadPhoto()} />
                            <MobileImagePanel siteId={null} loggerId={null} chariotId={deviceData?.lcloggerid} />
                        </div>
                    </Item>
                    <Item title={intl.formatMessage({ id: 'Comments' })}>
                        <div>
                            <Comments siteId={null} loggerId={null} lcLoggerId={deviceData?.lcloggerid} />
                        </div>
                    </Item>
                    <Item title={intl.formatMessage({ id: 'Events' })}>
                        <div>
                            <EventsPanelMobile serials={[deviceData?.serial]} />
                        </div>
                    </Item>
                    <Item title={intl.formatMessage({ id: 'Configuration Updates' })}>
                        <div>
                            <ConfigurationPanel serial={deviceData?.serial} />
                        </div>
                    </Item>
                </Accordion>
            </div>
        </div>}
    </div> :
        <Redirect push to={{
            pathname: redirectPath,
            state: redirectProps
        }} />
    }
    </>
    )
}
export default LCLDeviceDetailMobile